import { Col, Row, Input, Label, Button, ButtonGroup } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
const FreeTextEditor = props => {
  const {
    annotation: {
      freeTextAnnotation: {
        text,
        fontSize
      }
    },
    onChange
  } = props;
  const handleTextChange = ({
    target
  }) => onChange('freeTextAnnotation/text', target.value);
  const handleSizeIncrease = () => onChange('freeTextAnnotation/fontSize', fontSize + 1);
  const handleSizeDecrease = () => {
    if (fontSize >= 2) {
      onChange('freeTextAnnotation/fontSize', fontSize - 1);
    }
  };
  const labelStyle = {
    padding: '6.5px 0',
    minHeight: '32px'
  };
  const fontSizeStyle = {
    padding: '6.5px 0 0 5px',
    minHeight: '32px',
    fontWeight: 'bold'
  };
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(Label, null, "Text")), /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(Input, {
    className: "t-info-comments",
    type: "textarea",
    value: text || '',
    onChange: handleTextChange,
    style: {
      minHeight: '110px',
      height: '110px',
      resize: 'vertical'
    }
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(Label, {
    style: labelStyle
  }, "Font Size")), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Label, {
    style: fontSizeStyle
  }, fontSize || '')), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    className: "down-tick",
    onClick: handleSizeDecrease
  }, " - "), /*#__PURE__*/React.createElement(Button, {
    className: "up-tick",
    onClick: handleSizeIncrease
  }, " + "))));
};
FreeTextEditor.propTypes = {
  annotation: PropTypes.shape({
    freeTextAnnotation: PropTypes.shape({
      text: PropTypes.string,
      fontSize: PropTypes.number
    })
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
export default FreeTextEditor;